import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectDeepDiveComponent } from './project-deep-dive.component';


const routes: Routes = [
  {
    path: '',
    component: ProjectDeepDiveComponent
  },
  {
    path: ':id',
    component: ProjectDeepDiveComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectDeepDiveRoutingModule { }
